import React from 'react';
import ContentBox from '../../common/ContentBox';
import { Box, Divider, Typography } from '@mui/material';
import FundArray from './components/FundArray';
import FundTotal from './components/FundTotal';

const FundsTab: React.FC = () => {

    return <ContentBox proportion={1}>
        <Box display={"flex"} flexDirection={"column"} gap={"20px"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>Funds</Typography>
            <Divider sx={{ margin: "0 -32px"}} />
            <FundArray />
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>Total</Typography>
            <Divider sx={{ margin: "0 -32px"}} />
            <FundTotal />
        </Box>
    </ContentBox>;
}

export default FundsTab;